module.exports = __webpack_public_path__ + "static/media/1658587303instagram-png.142d6848.png";